import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetOrganizationModuleType } from "redux/organizationModuleSlice";


const useExpenseModule = () => {

  const [loading, setLoading] = useState(true); 
  const moduleType = useSelector((state) => state.moduleType);

  const dispatch = useDispatch();

  useEffect(() => {
    (async()=>{
      setLoading(true);
      await dispatch(fetchAsyncGetOrganizationModuleType());
      setLoading(false); 
    })()

  }, [dispatch]);

 
  return { 
    moduleType,
    loading,
    setLoading
   };
};

export default useExpenseModule;
